import api from '~/services/api';
import { toast } from 'react-toastify';
import {
  cartaForSubmit,
  cartaProps,
  responseData,
} from '../../protocols/CartaCorreacao';

const getProxNum = async (cod_seq_nf: number): Promise<number> => {
  try {
    const { data } = await api.get(
      `/manutencao-fiscal/getProxNum/${cod_seq_nf}`,
    );
    const { prox } = data.data;

    return prox;
  } catch (error) {
    toast.warning('Erro ao gerar próximo numero');
    return 0;
  }
};

const getCartaFields = async (cod_seq_nf: number): Promise<cartaProps[]> => {
  try {
    const { data } = await api.get(`/manutencao-fiscal/carta/${cod_seq_nf}`);
    const fields = data.data.map((value: cartaProps) => {
      return {
        cod_seq_nf: `${value.cod_seq_nf}`,
        num_seq: `${value.num_seq}`,
        des_titulo: `${value.des_titulo}`,
        des_cce: `${value.des_cce}`,
        dta_cadastro: `${value.dta_cadastro}`,
      };
    });

    return fields;
  } catch (error) {
    toast.warning('Erro ao buscar historico CCe');
    return [];
  }
};

const transmitirCCe = async (
  formCCe: cartaForSubmit,
): Promise<responseData> => {
  try {
    const { data } = await api.post(
      '/manutencao-fiscal/transmitirCCe',
      formCCe,
    );

    return data;
  } catch (error: any) {
    return { success: false, message: error.message };
  }
};

export const cartaServices = {
  getProxNum,
  getCartaFields,
  transmitirCCe,
};
